/* TRS Bundle Builder — 12-08-2026 */
(function () {
  var root = document.querySelector('[data-trsbb]');
  if (!root) return;

  /* Marks the page for stylesheet rules that must reach elements outside this
     section, such as the chat widget the theme appends straight to <body>. */
  document.documentElement.classList.add('trsbb-page');

  var VARIANT = root.dataset.variant;
  var FIXED = parseFloat(root.dataset.price) || 1699;

  var SRC = {
    toilet: 'toilet-bowl', vanity: 'bundle-vanity', top: 'bundle-top', basin: 'basin',
    tap: 'basin-faucet', shower: 'rain-shower', bidet: 'bidet',
    acc: 'bathroom-accessories', mirror: 'bundle-mirror'
  };

  var BASIN_PREF = {
    A: ['mount:top'],
    B: ['mount:inset', 'mount:undermount', 'mount:recess'],
    C: ['mount:console', 'mount:wall-hung', 'mount:semi-recess']
  };

  var ACC = [
    { k: 'acc1', cat: 'Accessory 1', src: 'acc' },
    { k: 'acc2', cat: 'Accessory 2', src: 'acc' },
    { k: 'acc3', cat: 'Accessory 3', src: 'acc' }
  ];
  var TAIL = [
    { k: 'tap', cat: 'Basin Tap', src: 'tap' },
    { k: 'shower', cat: 'Rainshower', src: 'shower' },
    { k: 'bidet', cat: 'Bidet Spray', src: 'bidet' }
  ];

  var PATHS = {
    A: { label: 'Stone top, with a basin sitting on it.',
      cart: 'Vanity + stone top + counter-top basin',
      slots: [
        { k: 'toilet', cat: 'Toilet Bowl', src: 'toilet' },
        { k: 'vanity', cat: 'Vanity Cabinet', src: 'vanity' },
        { k: 'top', cat: 'Vanity Top', src: 'top' },
        { k: 'basin', cat: 'Basin', src: 'basin' }
      ].concat(TAIL, ACC) },
    B: { label: 'Insert basin set into the vanity.',
      cart: 'Vanity with insert basin',
      slots: [
        { k: 'toilet', cat: 'Toilet Bowl', src: 'toilet' },
        { k: 'vanity', cat: 'Vanity Cabinet', src: 'vanity' },
        { k: 'basin', cat: 'Basin', src: 'basin' }
      ].concat(TAIL, ACC) },
    C: { label: 'Basin on its own, no vanity cabinet.',
      cart: 'Basin only, no vanity',
      slots: [
        { k: 'toilet', cat: 'Toilet Bowl', src: 'toilet' },
        { k: 'basin', cat: 'Basin', src: 'basin' }
      ].concat(TAIL, ACC) }
  };

  var path = 'A', picks = {}, addon = null, active = null, shownSaving = 0;
  /* The build lives in memory, so opening a product page or an accidental reload
     would otherwise wipe ten choices. sessionStorage keeps it for the tab only. */
  var SAVE_KEY = 'trsbb:build:v1';
  var cache = {}, inflight = {};
  var $ = function (id) { return document.getElementById(id); };
  var money = function (n) { return '$' + Math.round(n).toLocaleString('en-SG'); };
  /* No literal double-quote character appears anywhere in this file: the theme
     upload path mangles the newline after any line holding an odd number of them,
     so the escaper builds its quote from a char code instead. */
  var QUOTE = String.fromCharCode(34);
  var ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;' };
  ESCAPES[QUOTE] = '&quot;';
  var ESC_RE = new RegExp('[&<>' + QUOTE + ']', 'g');
  var esc = function (s) {
    return String(s == null ? '' : s).replace(ESC_RE, function (c) { return ESCAPES[c]; });
  };

  /* Titles on this catalogue usually start with the vendor already, so blindly
     prefixing it produced things like SANITON | SANITON | VERONICA ST2977. */
  function labelFor(item) {
    var t = item.title || '', b = item.brand || '';
    if (!b) return t;
    var norm = function (x) { return x.toLowerCase().replace(/[^a-z0-9]/g, ''); };
    return norm(t).indexOf(norm(b)) === 0 ? t : b + ' · ' + t;
  }

  /* The mirror cabinet is a real paid line, so it shows the price actually charged.
     Every other slot is inside the fixed price, so it shows the compare-at (retail)
     figure the bundle is being measured against. */
  function shownPrice(item, key) {
    return key === 'mirror' ? item.price : item.rrp;
  }

  function load(key) {
    if (cache[key]) return Promise.resolve(cache[key]);
    if (inflight[key]) return inflight[key];
    var handle = SRC[key], out = [], slotEx = 'bundle:exclude:' + key;
    var grab = function (page) {
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          var list = (d && d.products) || [];
          out = out.concat(list);
          if (list.length === 250 && page < 6) return grab(page + 1);
          return out;
        });
    };
    inflight[key] = grab(1).then(function (list) {
      cache[key] = list
        /* bundle:exclude keeps an item out of the builder entirely (spare parts,
           fittings). bundle:exclude:<slot> keeps it out of one slot only, so a
           mirror cabinet can stay a paid add-on while never being a free accessory. */
        .filter(function (p) {
          var tags = p.tags || [];
          return tags.indexOf('bundle:exclude') === -1 && tags.indexOf(slotEx) === -1;
        })
        .map(function (p) {
          var vs = p.variants || [], v = null, i;
          for (i = 0; i < vs.length; i++) { if (vs[i].available) { v = vs[i]; break; } }
          if (!v) v = vs[0];
          if (!v) return null;
          var price = parseFloat(v.price);
          var cmp = parseFloat(v.compare_at_price);
          return { id: v.id, title: p.title, brand: p.vendor || '',
            price: price,
            /* Fall back to price when compare-at is missing, zero, or below price. */
            rrp: (isFinite(cmp) && cmp > price) ? cmp : price,
            img: (p.images && p.images[0] && p.images[0].src) || '',
            url: p.handle ? '/products/' + p.handle : '',
            tags: p.tags || [] };
        })
        .filter(Boolean);
      delete inflight[key];
      return cache[key];
    });
    return inflight[key];
  }

  function widthOf(tags) {
    for (var i = 0; i < tags.length; i++) {
      var m = /^w:(\d{3,4})$/.exec(tags[i]);
      if (m) return parseInt(m[1], 10);
    }
    return null;
  }

  function rank(slot, item) {
    if (slot.src === 'basin') {
      var pref = BASIN_PREF[path] || [];
      var mounts = item.tags.filter(function (t) { return t.indexOf('mount:') === 0; });
      if (!mounts.length) return { fit: 1 };
      for (var i = 0; i < mounts.length; i++) if (pref.indexOf(mounts[i]) > -1) return { fit: 0 };
      return { fit: 2, note: 'Other mounting types' };
    }
    if (slot.src === 'top' && picks.vanity) {
      var vw = widthOf(picks.vanity.tags), tw = widthOf(item.tags);
      if (vw == null || tw == null) return { fit: 1 };
      if (Math.abs(vw - tw) <= 60) return { fit: 0 };
      return { fit: 2, note: 'Will not fit your ' + vw + 'mm vanity' };
    }
    return { fit: 1 };
  }

  function slotArt() {
    return '<svg viewBox="0 0 48 48" fill="none" stroke="#B6A991" stroke-width="1.5" width="38" height="38">' +
      '<rect x="9" y="9" width="30" height="30" rx="3" stroke-dasharray="4 4"/>' +
      '<path d="M24 18v12M18 24h12"/></svg>';
  }

  function renderSlots() {
    var slots = PATHS[path].slots;
    $('trsbb-grid').innerHTML = slots.map(function (s, i) {
      var p = picks[s.k], inner;
      if (p) {
        inner = '<div class="trsbb-thumb">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : slotArt()) + '</div>' +
          '<div class="trsbb-cat">' + esc(s.cat) + '</div>' +
          '<div class="trsbb-pick">' + esc(p.title) + '</div>' +
          '<div class="trsbb-acts"><button data-open="' + s.k + '">Change</button>' +
          '<button data-clear="' + s.k + '">Remove</button></div>';
      } else {
        inner = '<div class="trsbb-thumb">' + slotArt() + '</div>' +
          '<div class="trsbb-cat">' + esc(s.cat) + '</div>' +
          '<div class="trsbb-choose">+ Choose</div>';
      }
      return '<div class="trsbb-slot' + (p ? ' is-filled' : '') + '" data-slot="' + s.k + '">' +
        '<span class="n">' + (i + 1) + '</span>' + inner + '</div>';
    }).join('');

    $('trsbb-addonrow').innerHTML = addon
      ? '<div class="trsbb-addonpick"><div class="trsbb-thumb">' +
        (addon.img ? '<img src="' + esc(addon.img) + '" alt="">' : '') + '</div>' +
        '<div><strong>' + esc(addon.title) + '</strong><br>' + money(addon.price) + '</div></div>' +
        '<button class="trsbb-addonbtn" data-open="__mirror">Change</button>' +
        '<button class="trsbb-changepath" data-clear="__mirror">Remove</button>'
      : '<button class="trsbb-addonbtn" data-open="__mirror">Add a mirror cabinet</button>' +
        '<span style="font-size:13px;color:#6B6B6B">Sold at its own price, added as a separate line.</span>';

    updateTotals();
    saveBuild();
  }

  function countTo(el, to) {
    var from = shownSaving; shownSaving = to;
    var t0 = performance.now();
    (function step(t) {
      var k = Math.min(1, (t - t0) / 460), e = 1 - Math.pow(1 - k, 3);
      el.textContent = money(from + (to - from) * e);
      if (k < 1) requestAnimationFrame(step);
    })(t0);
  }

  function updateTotals() {
    var slots = PATHS[path].slots, total = slots.length;
    var chosen = slots.filter(function (s) { return picks[s.k]; });
    var sum = chosen.reduce(function (a, s) { return a + picks[s.k].rrp; }, 0);
    var left = total - chosen.length, diff = sum - FIXED;

    $('trsbb-cnt').textContent = chosen.length;
    $('trsbb-tot').textContent = total;
    $('trsbb-fill').style.width = (chosen.length / total * 100) + '%';
    $('trsbb-remain').textContent = left ? left + ' to go' : 'Ready to add';
    $('trsbb-barwas').textContent = sum ? 'Individually ' + money(sum) : '';
    $('trsbb-barsave').textContent = diff > 0 ? 'You save ' + money(diff) : '';
    $('trsbb-atc').disabled = left > 0;
    $('trsbb-was').textContent = money(sum);

    var sv = $('trsbb-sv');
    sv.classList.toggle('is-empty', chosen.length === 0);
    sv.classList.toggle('is-locked', left === 0 && diff > 0);
    if (diff > 0) {
      countTo($('trsbb-svbig'), diff);
      $('trsbb-svpct').textContent = Math.round(diff / sum * 100) + '% off retail';
      $('trsbb-svsub').textContent = left === 0
        ? 'Locked in. One price, one line at checkout.'
        : left + ' more to go. The saving grows with every box.';
    } else {
      shownSaving = 0;
      $('trsbb-svbig').textContent = '$0';
      $('trsbb-svpct').textContent = '';
      $('trsbb-svsub').textContent = 'Your saving grows with every box you fill.';
    }
  }

  function slotFor(key) {
    if (key === '__mirror') return { k: '__mirror', cat: 'Mirror Cabinet', src: 'mirror' };
    return PATHS[path].slots.filter(function (s) { return s.k === key; })[0];
  }

  function openPicker(key) {
    active = key;
    var slot = slotFor(key);
    if (!slot) return;
    $('trsbb-shtitle').textContent = 'Choose your ' + slot.cat.replace(/ \d$/, '').toLowerCase();
    $('trsbb-shsub').textContent = 'Loading…';
    $('trsbb-q').value = '';
    $('trsbb-sort').value = 'rec';
    $('trsbb-pgrid').innerHTML = '<div class="trsbb-loading">Loading products…</div>';
    $('trsbb-ov').hidden = false;
    document.body.style.overflow = 'hidden';
    load(slot.src).then(function (list) {
      if (active !== key) return;
      $('trsbb-shsub').textContent = list.length + ' products available';
      renderList();
    });
  }

  function closePicker() {
    $('trsbb-ov').hidden = true;
    document.body.style.overflow = '';
    active = null;
  }

  function renderList() {
    if (!active) return;
    var isMirror = active === '__mirror', slot = slotFor(active);
    var list = cache[slot.src] || [];
    var q = $('trsbb-q').value.toLowerCase().trim(), so = $('trsbb-sort').value;

    var rows = list.map(function (it) {
      var r = rank(slot, it);
      return { it: it, fit: r.fit, note: r.note, shown: shownPrice(it, slot.src) };
    });
    if (q) rows = rows.filter(function (r) {
      return (r.it.title + ' ' + r.it.brand).toLowerCase().indexOf(q) > -1;
    });

    if (so === 'lo') rows.sort(function (a, b) { return a.shown - b.shown; });
    else if (so === 'hi') rows.sort(function (a, b) { return b.shown - a.shown; });
    else if (so === 'az') rows.sort(function (a, b) { return a.it.title.localeCompare(b.it.title); });
    else rows.sort(function (a, b) { return a.fit - b.fit || a.shown - b.shown; });

    if (!rows.length) {
      $('trsbb-pgrid').innerHTML = '<div class="trsbb-empty">No products match that search.</div>';
      return;
    }

    var cur = isMirror ? addon : picks[active];
    var html = '', dividerDone = false;
    rows.forEach(function (r) {
      if (so === 'rec' && r.fit === 2 && !dividerDone) {
        dividerDone = true;
        html += '<div class="trsbb-divider">' + esc(r.note || 'Other options') + '</div>';
      }
      var chosen = cur && cur.id === r.it.id, elsewhere = [];
      if (!isMirror) {
        PATHS[path].slots.forEach(function (s) {
          if (s.k !== active && picks[s.k] && picks[s.k].id === r.it.id) elsewhere.push(s.cat);
        });
      }
      var openTag = r.it.url
        ? '<a class="trsbb-plink" href="' + esc(r.it.url) + '" target="_blank" rel="noopener">'
        : '<div class="trsbb-plink">';
      var closeTag = r.it.url ? '</a>' : '</div>';
      html += '<div class="trsbb-card' + (chosen ? ' is-chosen' : '') + (so === 'rec' && r.fit === 2 ? ' is-unfit' : '') + '">' +
        openTag +
        '<div class="trsbb-pimg">' + (r.it.img ? '<img src="' + esc(r.it.img) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="trsbb-pbrand">' + esc(r.it.brand) + '</div>' +
        '<div class="trsbb-ptitle">' + esc(r.it.title) + '</div>' +
        (r.it.url ? '<span class="trsbb-pview">View details &#8599;</span>' : '') +
        closeTag +
        '<div class="trsbb-pprice">' + money(r.shown) + '</div>' +
        (elsewhere.length ? '<div class="trsbb-used">Already in ' + esc(elsewhere.join(', ')) + '</div>' : '') +
        '<button class="trsbb-sel" data-pick="' + r.it.id + '">' + (chosen ? '✓ Selected' : 'Select') + '</button>' +
        '</div>';
    });
    $('trsbb-pgrid').innerHTML = html;
  }

  /* Hands the updated cart to Dawn's drawer instead of navigating to /cart. We ask
     /cart/add.js for the rendered sections in the same round trip; the theme's global
     fetch hook (assets/cart-drawer.js) deliberately stands down when a response already
     carries `sections`, so the drawer is rendered here exactly once. */
  function openDrawer(data) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !data || !data.sections || typeof drawer.renderContents !== 'function') {
      window.location.href = '/cart';
      return false;
    }
    drawer.classList.remove('is-empty');
    var inner = drawer.querySelector('.drawer__inner');
    if (inner) inner.classList.remove('is-empty');
    drawer.renderContents(data);
    return true;
  }

  function addToCart() {
    var slots = PATHS[path].slots;
    /* Short noun phrase, not the on-page sentence: this string is shown as a
       cart line property and again at checkout, where a full sentence with a
       full stop reads badly. */
    var props = { 'Bundle layout': PATHS[path].cart };
    slots.forEach(function (s) {
      var p = picks[s.k];
      if (p) {
        props[s.cat] = labelFor(p);
        props['_' + s.k + '_variant'] = String(p.id);
        /* Hidden, keyed off the visible property name so the cart template can pair a
           thumbnail to each pick without a variant lookup. */
        if (p.img) props['_img:' + s.cat] = p.img;
      }
    });
    var items = [{ id: Number(VARIANT), quantity: 1, properties: props }];
    if (addon) items.push({ id: Number(addon.id), quantity: 1, properties: { 'Added with': 'Bathroom Bundle' } });

    var btn = $('trsbb-atc');
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function (data) {
      btn.removeAttribute('aria-busy');
      if (openDrawer(data)) updateTotals();
    })
    ['catch'](function () {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
      alert('Something went wrong adding your bundle. Please try again, or message us on WhatsApp.');
    });
  }

  /* Chaty's WhatsApp bubble is fixed bottom-right at z-index 997, so it sat on top
     of the sticky CTA bar (z-index 40) — worst on mobile, where the bar is full
     width and the bubble covered the button text. Publishing the bar's measured
     height lets the stylesheet lift the bubble clear of it, whatever the bar's
     height happens to be on that viewport. */
  function syncBarHeight() {
    var bar = $('trsbb-bar');
    var h = bar && !bar.hidden ? Math.ceil(bar.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--trsbb-bar-h', h + 'px');
  }

  function saveBuild() {
    try { sessionStorage.setItem(SAVE_KEY, JSON.stringify({ p: path, picks: picks, addon: addon })); }
    catch (e) {}
  }

  function loadBuild() {
    try {
      var s = JSON.parse(sessionStorage.getItem(SAVE_KEY) || 'null');
      return s && PATHS[s.p] ? s : null;
    } catch (e) { return null; }
  }

  function selectPath(key, scroll, keepPicks) {
    path = key;
    if (!keepPicks) picks = {};
    Array.prototype.forEach.call(document.querySelectorAll('[data-path]'), function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.path === key));
    });
    $('trsbb-pathlabel').textContent = PATHS[key].label;
    $('trsbb-build').hidden = false;
    $('trsbb-savings').hidden = false;
    $('trsbb-bar').hidden = false;
    renderSlots();
    saveBuild();
    syncBarHeight();
    if (scroll) $('trsbb-build').scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.addEventListener('click', function (e) {
    var pathBtn = e.target.closest('[data-path]');
    if (pathBtn) { selectPath(pathBtn.dataset.path, true); return; }
    if (e.target.closest('[data-changepath]')) {
      $('trsbb-paths').scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var open = e.target.closest('[data-open]');
    if (open) { openPicker(open.dataset.open); return; }
    var clear = e.target.closest('[data-clear]');
    if (clear) {
      e.stopPropagation();
      if (clear.dataset.clear === '__mirror') addon = null; else delete picks[clear.dataset.clear];
      renderSlots();
      return;
    }
    var pick = e.target.closest('[data-pick]');
    if (pick) {
      var id = Number(pick.dataset.pick), isMirror = active === '__mirror';
      var slot = slotFor(active);
      var item = (cache[slot.src] || []).filter(function (x) { return x.id === id; })[0];
      if (item) {
        if (isMirror) addon = item; else picks[active] = item;
        renderSlots();
        closePicker();
      }
      return;
    }
    var slotEl = e.target.closest('[data-slot]');
    if (slotEl && !e.target.closest('button')) { openPicker(slotEl.dataset.slot); return; }
    if (e.target === $('trsbb-ov')) closePicker();
  });

  $('trsbb-shx').addEventListener('click', closePicker);
  $('trsbb-q').addEventListener('input', renderList);
  $('trsbb-sort').addEventListener('change', renderList);
  $('trsbb-atc').addEventListener('click', addToCart);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !$('trsbb-ov').hidden) closePicker();
  });

  /* Boxes visible from first load; the count changes only when a layout is chosen.
     A saved build is restored first, so returning from a product page keeps it. */
  var saved = loadBuild();
  if (saved) {
    picks = saved.picks || {};
    addon = saved.addon || null;
    selectPath(saved.p, false, true);
  } else {
    selectPath('A', false);
  }

  syncBarHeight();
  window.addEventListener('resize', syncBarHeight);
  window.addEventListener('orientationchange', syncBarHeight);
  if (window.ResizeObserver) new ResizeObserver(syncBarHeight).observe($('trsbb-bar'));
})();